import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import classNames from "classnames";
import { useDisclosure } from "../utils";
import { PageContainer } from "./PageContainer";
export function Accordion(_param) {
    var children = _param.children, className = _param.className, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx(PageContainer, _object_spread_props(_object_spread({
        className: classNames("section dark:text-gray-100 py-20", className)
    }, rest), {
        children: /*#__PURE__*/ _jsx("div", {
            className: "",
            children: /*#__PURE__*/ _jsx("div", {
                className: "has-mw-4xl mx-auto",
                children: /*#__PURE__*/ _jsx("ul", {
                    className: "space-y-6",
                    children: children
                })
            })
        })
    }));
}
function AccordionItem(param) {
    var heading = param.heading, content = param.content;
    var ref = useDisclosure(), toggle = ref.toggle, isOpen = ref.isOpen;
    var Icon = isOpen ? MaterialSymbolsKeyboardArrowUpRounded : MaterialSymbolsKeyboardArrowDownRounded;
    return /*#__PURE__*/ _jsxs("li", {
        className: "flex flex-col space-y-4 bg-gray-200/50 backdrop-blur rounded dark:bg-gray-900/40 border p-6 ",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                onClick: toggle,
                className: "cursor-pointer flex items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-xl font-medium",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-auto"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: toggle,
                        className: "rounded",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            className: "w-6 h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames("block", isOpen ? "" : "hidden"),
                children: /*#__PURE__*/ _jsx("div", {
                    className: classNames("block whitespace-pre-wrap opacity-90 leading-relaxed"),
                    children: content
                })
            })
        ]
    });
}
export var Faq = function(param) {
    var items = param.items, className = param.className;
    return /*#__PURE__*/ _jsx(PageContainer, {
        children: /*#__PURE__*/ _jsx(Accordion, {
            className: className,
            children: items.map(function(item, i) {
                return /*#__PURE__*/ _createElement(AccordionItem, _object_spread_props(_object_spread({}, item), {
                    key: "item-".concat(i)
                }));
            })
        })
    });
};
function MaterialSymbolsKeyboardArrowDownRounded(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M12 14.975q-.2 0-.387-.075q-.188-.075-.313-.2l-4.6-4.6q-.275-.275-.275-.7q0-.425.275-.7q.275-.275.7-.275q.425 0 .7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275q.425 0 .7.275q.275.275.275.7q0 .425-.275.7l-4.6 4.6q-.15.15-.325.212q-.175.063-.375.063Z"
        })
    }));
}
function MaterialSymbolsKeyboardArrowUpRounded(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M6.7 14.7q-.275-.275-.275-.7q0-.425.275-.7l4.6-4.6q.15-.15.325-.213q.175-.062.375-.062t.388.075q.187.075.312.2l4.6 4.6q.275.275.275.7q0 .425-.275.7q-.275.275-.7.275q-.425 0-.7-.275L12 10.8l-3.9 3.9q-.275.275-.7.275q-.425 0-.7-.275Z"
        })
    }));
}
